/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as packageInfo from '../../../package.json';

// Component imports
import { Col, Layout, Row, Space, Tooltip } from 'antd';
import DevLanguagePicker from '../UI/DevLanguagePicker';

// Misc imports
import { BRANCH, BUILD_ENV, BUILD_NUMBER, IS_HRWIZ_CONSOLE_ENABLED, IS_HRWIZ_FOOTER_DISABLED, PRODUCT_VERSION } from '../../constants/env';
import AppLogoDark from '../../assets/logo-full-dark.svg';

// Constant declarations
const { Footer } = Layout;

const GlobalFooter = () => {
  const { version } = packageInfo ? packageInfo.default : {};
  const { t } = useTranslation();
  const { footerContent } = useSelector((state) => state.global);

  const renderPoweredBy = () => {
    if (IS_HRWIZ_CONSOLE_ENABLED && IS_HRWIZ_FOOTER_DISABLED) {
      return null;
    } else {
      return (
        <Fragment>
          {t('Powered by')}

          <img src={AppLogoDark} alt="Helvia Technologies" className="ml-1 v-align-sub" style={{ height: '1.3em' }} />
        </Fragment>
      );
    }
  };

  return (
    <Footer className="fs-sm text-secondary px-0">
      <Row justify="center">
        <Col flex="auto">
          {footerContent}
        </Col>

        <Col flex="none">
          <Space size={3}>
            {
              PRODUCT_VERSION ? (
                <Tooltip
                  title={
                    version || BUILD_ENV || BRANCH || BUILD_NUMBER ? (
                      <Fragment>
                        <p className="mb-0">{ version ? `Dev version: ${version}` : '' }</p>
                        <p className="mb-0">{ BUILD_ENV ? `Env: ${BUILD_ENV}` : '' }</p>
                        <p className="mb-0">{ BUILD_NUMBER ? `Build: ${BUILD_NUMBER}` : '' }</p>
                        <p className="mb-0">{ BRANCH ? `Branch: ${BRANCH}` : '' }</p>
                      </Fragment>
                    ) : null
                  }
                >
                  {t('Helvia.ai Agent Platform')} {PRODUCT_VERSION} &bull;
                </Tooltip>
              ) : null
            }

            {renderPoweredBy()}

            <DevLanguagePicker className="ml-2" />
          </Space>
        </Col>
      </Row>
    </Footer>
  );
};

export default GlobalFooter;
